<template>
  <div class="container">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div v-if="!loading" class="mt-4 mb-4 refund-page">
        <h3>Refusjon for ordre betalt med kontant via kasse</h3>
        <div class="mt-4">{{getOrderTypeText()}} - Ordre #{{order.orderId}}</div>

        <div v-if="step == 1">
          <div class="mt-5 mb-0">
            <button type="button" class="bo_btn" @click="selectAllOrRemoveAll"> {{selectAllOrRemoveAllButtonText()}} </button>
          </div>
          <hr class="mb-0"/>
          <div v-for="refundCartItem in refundCartItems" :key="refundCartItem.id" :id="refundCartItem.id" class="refundCartItem">
            <div class="d-flex align-items-center justify-content-between clickable-row" @click="updateSelectedCartItems(refundCartItem)">
              <div class="d-flex align-items-center">
                <input type="checkbox" :name="refundCartItem.id" :value="refundCartItem.id" :checked="selectedCartItemsContains(refundCartItem)" @click.stop="updateSelectedCartItems(refundCartItem)" class="checkbox" />
                <div>
                  <div>
                    {{ refundCartItem.itemName }}
                  </div>
                  <div v-if="refundCartItem.itemSubselection">
                    {{ refundCartItem.itemSubselection.name }}
                  </div>
                  <div v-if="refundCartItem.spicyLevel != ''">
                    {{ refundCartItem.spicyLevel}}
                  </div>
                  <div v-if="refundCartItem.comment != ''">
                    {{ refundCartItem.comment }}
                  </div>
                </div>
              </div>
              <div>
                {{ displayTwoDecimals(getPriceWithVat(refundCartItem)) }}
              </div>
            </div>
          </div>
          <div v-if="order.tipsAmount && order.tipsAmount > 0" class="mt-2">
            <div class="d-flex align-items-center justify-content-between clickable-row" @click="updateRefundedTipsAmount()">
              <div class="d-flex align-items-center">
                <input type="checkbox" :name="'tips_' + order.orderId" :value="'tips_' + order.orderId"
                       :checked="refundedTipsAmount > 0" @click.stop="updateRefundedTipsAmount()"
                       class="checkbox" />
                <div> Tips </div>
              </div>
              <div>
                {{ displayTwoDecimals(order.tipsAmount) }}
              </div>
            </div>
          </div>

          <div class="bo_savebtn_container mt-5 mb-5">
            <button type="button" class="bo_btn" @click="step=2" :disabled="disableNextBtn()">Neste</button>
          </div>
        </div>

        <div v-if="step == 2">
          <hr class="mb-0"/>
          <div v-for="selectedCartItem in selectedCartItems" :key="selectedCartItem.id" :id="selectedCartItem.id" class="refundCartItem">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div>
                  <div>
                    -1 x {{selectedCartItem.itemName}}
                  </div>
                  <div v-if="selectedCartItem.itemSubselection">
                    {{ selectedCartItem.itemSubselection.name }}
                  </div>
                  <div v-if="selectedCartItem.spicyLevel != ''">
                    {{ selectedCartItem.spicyLevel}}
                  </div>
                  <div v-if="selectedCartItem.comment != ''">
                    {{ selectedCartItem.comment }}
                  </div>
                </div>
              </div>
              <div>
                -{{ displayTwoDecimals(getPriceWithVat(selectedCartItem)) }}
              </div>
            </div>
          </div>
          <div v-if="refundedTipsAmount > 0" class="mt-2 mb-3">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div> -Tips </div>
              </div>
              <div>
                -{{ displayTwoDecimals(refundedTipsAmount) }}
              </div>
            </div>
          </div>

          <div v-if="getCashRounding() !== 0" class="d-flex align-items-center justify-content-between">
            <div>Øreavrunding</div>
            <div>{{ getCashRounding() > 0 ? '+' : '-' }}{{ displayTwoDecimals(Math.abs(getCashRounding())) }}</div>
          </div>

          <div class="d-flex align-items-center justify-content-between">
            <div>
              <span style="font-weight: bold;">Kontant tilbake</span>
            </div>
            <div>
              <span style="font-weight: bold;color: red">-{{ displayTwoDecimals(getCashRefundAmount()) }}</span>
            </div>
          </div>

          <div class="bo_savebtn_container mt-5 mb-5">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <button type="button" class="bo_btn" @click="step=1">Tilbake</button>
              </div>
              <div>
                <button type="button" class="bo_btn" @click="refund">Refunder</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ConfirmDialogue ref="confirmDialogue"></ConfirmDialogue>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import OrderService from "@/services/order/OrderService";
import OrderUtil from "@/util/OrderUtil";
import VatUtil from "@/util/VatUtil";
import ConfirmDialogue from "@/components/other/ConfirmDialogue";
import MathUtil from "@/util/MathUtil";
import CashService from "@/services/payment/CashService";
import RefundJournal from "@/util/RefundJournal";

export default {
  components: {LoadingSpinner, ConfirmDialogue},
  data() {
    return {
      loading: true,
      step: 1,

      vat: {},
      orderDocumentId: '',
      order: {
        type: "order",
        merchant: '',
        orderId: '',
        orderType: '',
        orderStatus: '',
        totalAmount: 0,
        description: '',
        pickupOrDeliveryTime: '',
        mobileNumber: '',
        name: '',
        nameOnDoorbell: '',
        street: '',
        houseNumber: '',
        floor: '',
        zipCode: '',
        city: '',
        orderedTime: '',
        modifiedTime: '',
        servedBy: '',
        channel: '',
        payments: [],
        vats: [],
        totalVat: 0,
        cartItemsJson: []
      },
      refundCartItems: [],
      refundedTipsAmount : 0,
      selectedCartItems: []
    };
  },
  mounted() {
    document.getElementById('nav').hidden = true;
    document.getElementById('footer').hidden = true;
    document.getElementById('scrollTopBtn').hidden = true;

    this.orderDocumentId = this.$route.query.orderDocumentId;
    OrderService.getDataForOrderDetailGui(this.orderDocumentId).then(
        (response) => {
          let dataForGui = response.data;
          //console.log('dataForGui: ' + JSON.stringify(dataForGui));
          this.order = dataForGui.order;
          this.vat = dataForGui.vat;
          this.refundCartItems = this.getRefundCartItems();
          this.loading = false;
        },
        (error) => {
          console.log(error);
        }
    );
  },
  methods:{
    getOnlinePaymentProvider(){
      let onlinePaymentProvider = OrderUtil.getOnlinePaymentProvider(this.order.payments);
      return onlinePaymentProvider;
    },

    getRefundCartItems(){
      let refundCartItems = [];
      let cartItems = this.order.cartItems;
      console.log('cartItems: ' + JSON.stringify(cartItems));
      for (let i = 0; i < cartItems.length; i++) {
        let cartItem = cartItems[i];
        for(let x = 1; x <= cartItem.count; x++){
          let refundCartItem = {
            originalCartItemId : cartItem.id,
            id: cartItem.id + '_' + x, //make it unique
            itemId: cartItem.itemId,
            itemName: cartItem.itemName + OrderUtil.shareSuffix(cartItem),
            shareAmount: cartItem.shareAmount,
            shareNumerator: cartItem.shareNumerator,
            shareDenominator: cartItem.shareDenominator,
            shareOfCount: cartItem.shareOfCount,
            itemType: cartItem.itemType,
            price: cartItem.price,
            discountPercent: cartItem.discountPercent ? cartItem.discountPercent : 0,
            count: 1,
            itemSubselection: cartItem.itemSubselection,
            spicyLevel: cartItem.spicyLevel,
            comment: cartItem.comment,
            createdDate: cartItem.createdDate
          };
          refundCartItems.push(refundCartItem);

          //subselection addOns
          if(refundCartItem.itemSubselection){
            let subselectionAddOnCartItems =  refundCartItem.itemSubselection.addOnCartItems;
            if(subselectionAddOnCartItems){
              for(let a = 0; a < subselectionAddOnCartItems.length; a++){
                let addOnCartItem = subselectionAddOnCartItems[a];
                let addOn = addOnCartItem.addOn;
                for(let y = 1; y <= addOnCartItem.count; y++){
                  //Only if it isn't free
                  if(addOnCartItem.price > 0){
                    let addOnRefundCartItem = {
                      originalCartItemId : cartItem.id, //The id of the parent cartItem the addon belongs to.
                      id: cartItem.id + '_' + x + '_' + addOnCartItem.addOnId + '_' + y, //make it unique
                      itemId: addOnCartItem.addOnId,
                      itemName: addOn.name,
                      itemType: 'ADD_ON_OF_ADD_ON_GROUP',
                      price: addOnCartItem.price,
                      discountPercent: cartItem.discountPercent ? cartItem.discountPercent : 0, //The same as cartItem.discountPercent
                      count: 1,
                      createdDate: cartItem.createdDate
                    };
                    refundCartItems.push(addOnRefundCartItem);
                  }
                }
              }
            }
          }

          //item addOns
          if(cartItem.addOnCartItems && cartItem.addOnCartItems.length > 0){
            for (let a = 0; a < cartItem.addOnCartItems.length; a++) {
              let addOnCartItem = cartItem.addOnCartItems[a];
              let addOn = addOnCartItem.addOn;
              for(let y = 1; y <= addOnCartItem.count; y++){
                //Only if it isn't free
                if(addOnCartItem.price > 0){
                  let addOnRefundCartItem = {
                    originalCartItemId : cartItem.id, //The id of the parent cartItem the addon belongs to.
                    id: cartItem.id + '_' + x + '_' + addOnCartItem.addOnId + '_' + y, //make it unique
                    itemId: addOnCartItem.addOnId,
                    itemName: addOn.name,
                    itemType: 'ADD_ON_OF_ADD_ON_GROUP',
                    price: addOnCartItem.price,
                    discountPercent: cartItem.discountPercent ? cartItem.discountPercent : 0, //The same as cartItem.discountPercent
                    count: 1,
                    createdDate: cartItem.createdDate
                  };
                  refundCartItems.push(addOnRefundCartItem);
                }
              }
            }
          }
        }
      }
      return refundCartItems;
    },

    getOrderTypeText(){
      return OrderUtil.getOrderTypeText(this.order.orderType).toUpperCase();
    },
    getPriceWithVat(cartItem){
      if(OrderUtil.isShare(cartItem) && !(this.order.manualDiscount > 0)){
        return OrderUtil.shareAmount(cartItem); //a share as the till worked it out, never rounded to whole kroner
      }
      // Check if this order has manual discount - if so, use proportional calculation
      if(this.order.manualDiscount && this.order.manualDiscount > 0){
        return this.getPriceWithVatAndManualDiscount(cartItem);
      }
      
      // Original logic for orders without manual discount
      let vatRate = VatUtil.getVatRate(this.vat, this.order.orderType, cartItem.itemType);
      let priceWithVat = OrderUtil.getPriceWithVat(vatRate, cartItem.price) * (100 - cartItem.discountPercent) / 100;
      if(cartItem.discountPercent == 0){
        return Math.round(priceWithVat); //make it exact as it is in order description.
      } else {
        return MathUtil.roundTwoDecimals(priceWithVat);
      }
    },
    getPriceWithVatAndManualDiscount(cartItem){
      // For orders with manual discount, calculate proportional price based on final amount paid
      let totalPaidAmount = this.order.toPayAmount || this.order.totalAmount;
      
      // Calculate expected total without tips and manual discount
      let expectedProductTotal = totalPaidAmount - (this.order.tipsAmount || 0);
      
      // Calculate sum of all base prices (without manual discount) for all refund cart items
      let totalBasePrice = 0;
      this.refundCartItems.forEach(item => {
        let vatRate = VatUtil.getVatRate(this.vat, this.order.orderType, item.itemType);
        let basePriceWithVat = OrderUtil.getPriceWithVat(vatRate, item.price) * (100 - item.discountPercent) / 100;
        totalBasePrice += basePriceWithVat;
      });
      
      // If there's only one item, it gets the full expected amount
      if(this.refundCartItems.length === 1){
        return MathUtil.roundTwoDecimals(expectedProductTotal);
      }
      
      // Find which item index this is
      let itemIndex = this.refundCartItems.findIndex(item => item.id === cartItem.id);
      if(itemIndex === -1){
        // Fallback to original calculation
        let vatRate = VatUtil.getVatRate(this.vat, this.order.orderType, cartItem.itemType);
        let priceWithVat = OrderUtil.getPriceWithVat(vatRate, cartItem.price) * (100 - cartItem.discountPercent) / 100;
        return MathUtil.roundTwoDecimals(priceWithVat);
      }
      
      // For multiple items, distribute proportionally but adjust last item for exact match
      let vatRate = VatUtil.getVatRate(this.vat, this.order.orderType, cartItem.itemType);
      let basePrice = OrderUtil.getPriceWithVat(vatRate, cartItem.price) * (100 - cartItem.discountPercent) / 100;
      let proportionalPrice = (basePrice / totalBasePrice) * expectedProductTotal;
      
      // If this is the last item, calculate what's left to ensure exact match
      if(itemIndex === this.refundCartItems.length - 1){
        let alreadyAllocated = 0;
        for(let i = 0; i < this.refundCartItems.length - 1; i++){
          let otherItem = this.refundCartItems[i];
          let otherVatRate = VatUtil.getVatRate(this.vat, this.order.orderType, otherItem.itemType);
          let otherBasePrice = OrderUtil.getPriceWithVat(otherVatRate, otherItem.price) * (100 - otherItem.discountPercent) / 100;
          let otherProportional = (otherBasePrice / totalBasePrice) * expectedProductTotal;
          alreadyAllocated += MathUtil.roundTwoDecimals(otherProportional);
        }
        return MathUtil.roundTwoDecimals(expectedProductTotal - alreadyAllocated);
      }
      
      return MathUtil.roundTwoDecimals(proportionalPrice);
    },
    disableNextBtn(){
      let disabled = this.selectedCartItems.length == 0;
      if(this.order.tipsAmount && this.order.tipsAmount > 0 && disabled){
        if(this.refundedTipsAmount == 0){
          disabled = true;
        } else {
          disabled = false;
        }
      }
      return disabled;
    },
    selectAllOrRemoveAllButtonText(){
      if(this.order.tipsAmount && this.order.tipsAmount > 0){
        if(this.selectedCartItems.length == this.refundCartItems.length && this.refundedTipsAmount > 0){
          return 'Fjern alle valgte';
        }else {
          return 'Velg alle';
        }
      } else {
        if(this.selectedCartItems.length == this.refundCartItems.length){
          return 'Fjern alle valgte';
        }else {
          return 'Velg alle';
        }
      }
    },
    selectAllOrRemoveAll(){
      //console.log('BEFORE: ' + JSON.stringify(this.selectedCartItems));
      if(this.selectedCartItems.length == this.refundCartItems.length){
        //Remove all
        this.selectedCartItems = [];
        this.refundedTipsAmount = 0;
      }else {
        //Add all
        for (let i = 0; i < this.refundCartItems.length; i++) {
          if(!this.selectedCartItemsContains(this.refundCartItems[i])){
            this.selectedCartItems.push(this.refundCartItems[i]);
          }
        }
        this.refundedTipsAmount = this.order.tipsAmount ? this.order.tipsAmount : 0;
      }
      //console.log('AFTER: ' + JSON.stringify(this.selectedCartItems));
    },
    updateRefundedTipsAmount(){
      if(this.refundedTipsAmount > 0){
        this.refundedTipsAmount = 0;
      } else {
        this.refundedTipsAmount = this.order.tipsAmount;
      }
    },
    updateSelectedCartItems(refundCartItem){
      console.log('BEFORE: ' + JSON.stringify(this.selectedCartItems));
      if(this.selectedCartItemsContains(refundCartItem)){
        //Already selected, remove it
        for (let i = 0; i < this.selectedCartItems.length; i++) {
          if (this.selectedCartItems[i].id == refundCartItem.id) {
            this.selectedCartItems.splice(i, 1);
            break;
          }
        }
      }else {
        //Add it
        this.selectedCartItems.push(refundCartItem);
      }
      console.log('AFTER: ' + JSON.stringify(this.selectedCartItems));
    },
    selectedCartItemsContains(cartItem){
      for (let i = 0; i < this.selectedCartItems.length; i++) {
        let selectedCartItem = this.selectedCartItems[i];
        if(selectedCartItem.id == cartItem.id){
          return true;
        }
      }
      return false;
    },
    /**
     * The cash handed back: what the refunded lines come to, in whole kroner, as the cash was taken. There is no øre
     * coin. The server rounds it the same way and records it so (CashRefund); the lines keep their øre.
     */
    getCashRefundAmount(){
      return MathUtil.roundCash(this.getTotalRefundAmount());
    },
    /** What the lines came to, less the cash handed back: shown as «Øreavrunding», as on a cash receipt. */
    getCashRounding(){
      return MathUtil.roundTwoDecimals(this.getTotalRefundAmount() - this.getCashRefundAmount());
    },
    getTotalRefundAmount(){
      let totalPricesInCart = 0.00;
      for (let i = 0; i < this.selectedCartItems.length; i++) {
        let selectedCartItem = this.selectedCartItems[i];
        let cartItemPrice = this.getPriceWithVat(selectedCartItem);
        console.log(cartItemPrice);
        totalPricesInCart = totalPricesInCart + cartItemPrice;
      }

      totalPricesInCart = totalPricesInCart + this.refundedTipsAmount;
      return totalPricesInCart;
    },
    getTransactionId(){
      let payments = this.order.payments;
      for (let i = 0; i < payments.length; i++) {
        let payment = payments[i];
        if(payment.transactionId){
          return payment.transactionId;
        }
      }
      return null;
    },
    async refund(){
      const ok = await this.$refs.confirmDialogue.show({
        title: 'Refundere kr ' + this.displayTwoDecimals(this.getCashRefundAmount()),
        message: 'Vil du refundere kr ' + this.displayTwoDecimals(this.getCashRefundAmount()) + ' kontant til kunden?',
        okButton: 'Refunder',
        cancelButton: 'Avbryt',
        spreadButtons: true,
      })
      if(ok) {
        if(this.getOnlinePaymentProvider() == 'NOT_ANY'){ //Cash order
          this.openCashDrawer();
          await this.confirmPayBack();
        }
      } else {
        //Cancel, do nothing
        console.log('OnlinePaymentProvider NOT supported');
      }
    },
    async confirmPayBack(){
      const ok = await this.$refs.confirmDialogue.show({
        title: 'Betal tilbake NOK ' + this.displayTwoDecimals(this.getCashRefundAmount()),
        message: 'Betal tilbake kontant NOK ' + this.displayTwoDecimals(this.getCashRefundAmount()) + ' til kunden. Trykk deretter på Bekreft for å fullføre refusjonen.',
        okButton: 'Bekreft',
        cancelButton: 'Avbryt',
        spreadButtons: true,
      })
      if(ok) {
        this.loading = true;
        this.refundOrder();
      } else {
        //Cancel, do nothing
        console.log('Refund aborted');
      }
    },
    openCashDrawer(){
      if(window.JSBridge && window.JSBridge.openCashDrawer) {
        window.JSBridge.openCashDrawer();
      }
    },
    incrementGrandTotalRefund(refundAmount, orderDocumentId){
      if(window.JSBridge && window.JSBridge.incrementGrandTotalRefund) {
        window.JSBridge.incrementGrandTotalRefund(refundAmount, orderDocumentId);
      }
    },
    refundOrder(){
      // Create a copy of selectedCartItems with base prices (without manual discount applied)
      // This follows the same pattern as PayMyPartOrderRefund.vue
      const refundedCartItemsWithVat = this.selectedCartItems.map(cartItem => {
        if (OrderUtil.isShare(cartItem)) {
          // A share at its own amount, as the till sold it: its price rounded to whole kroner refunded a third
          // of a 499 bottle as 166 and left the VAT and the category short.
          return { ...cartItem, price: OrderUtil.shareAmount(cartItem) };
        }
        // Calculate VAT-inclusive price based on the original base price (without manual discount)
        let vatRate = VatUtil.getVatRate(this.vat, this.order.orderType, cartItem.itemType);
        let priceWithVat = OrderUtil.getPriceWithVat(vatRate, cartItem.price) * (100 - cartItem.discountPercent) / 100;
        let finalPrice = cartItem.discountPercent == 0 ? Math.round(priceWithVat) : MathUtil.roundTwoDecimals(priceWithVat);
        
        return {
          ...cartItem,
          price: finalPrice
        };
      });

      CashService.refund(this.getTotalRefundAmount(), refundedCartItemsWithVat, this.refundedTipsAmount, this.orderDocumentId).then(
          (response) => {
            if(response.data === 'SUCCEEDED'){
              // The grand total of returns at what the lines came to, as the grand total of sales counts a cash sale
              // (its øre); the cash handed back is whole kroner (getCashRefundAmount).
              this.incrementGrandTotalRefund(this.getTotalRefundAmount(), this.orderDocumentId);
              // The return in the till's journal: the lines at what they came to, the cash in whole kroner.
              RefundJournal.send({
                order: this.order,
                orderDocumentId: this.orderDocumentId,
                rows: this.selectedCartItems,
                priceOf: row => this.getPriceWithVat(row),
                paidBack: [{ paymentType: 'CASH', amount: this.getCashRefundAmount() }],
                tips: this.refundedTipsAmount,
              });
              this.goToOrderDetailPage();
            }else {
              this.showUpdatingOrderFailedMessage();
              this.loading = false;
            }
          },
          (error) => {
            console.log(error);
          }
      );
    },
    goToOrderDetailPage(){
      this.$router.push({ path: 'orderDetail', query: {
          orderDocumentId: this.orderDocumentId,
          showRefundInfo: 'false'
        }
      });
    },
    async showUpdatingOrderFailedMessage(){
      const ok = await this.$refs.confirmDialogue.show({
        title: 'Refusjonen vellykket',
        message: 'Refusjonen ble fullført. Men det skjedde en feil ved oppdatering av ordren i systemet. Vennligst kontakt CAGISTA Support.',
        okButton: 'OK',
        cancelButton: 'NOT_SET'
      })
      if(ok) {
        //Do nothing
      }
    },
    displayTwoDecimals(num){
      if(num > 0 || num < 0){
        return MathUtil.displayTwoDecimals(num);
      }else {
        return num;
      }
    }
  }
}
</script>

<style scoped>
  .refundCartItem{
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: var(--bo-muted-2);
    border-bottom: 1px  solid var(--bo-muted-2);
  }

  .checkbox{
    width: 25px;
    height: 25px;
    margin-right: 10px;
  }
</style>
